import constant from '../../constant'

const initialState = {
  isInit: false,
  show: false,
};

export function recommendPop (state = initialState, action) {
  switch (action.type) {
    case constant.RECOMMEND_POP.SET_STATUS:
      return {
        ...state,
        ...action
      }
    default:
      return state
  }
}